import { dynamicLoader } from '~/utils';

export const ProjectEditor = dynamicLoader({
  name: 'ProjectEditorWrapper',
  importFunc: () => import('./project-editor-wrapper'),
});